import React, { useState } from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

/**
 * Technische Legacy-Angaben, eingeklappt (#1245).
 *
 * Opcodes, Registernummern und Rohschlüssel gehören nicht in die normale
 * Ansicht — wer sie braucht, klappt sie auf. Für die spätere Arbeit am
 * Entscheidungsbaum sind sie unentbehrlich, für eine Zuordnungsentscheidung
 * meistens nur Lärm.
 */

interface Props {
  entries: { label: string; value: React.ReactNode }[];
  label?: string;
}

export const TechnicalDetails: React.FC<Props> = ({
  entries,
  label = 'Technische Details anzeigen',
}) => {
  const [open, setOpen] = useState(false);
  const visible = entries.filter(
    entry =>
      entry.value !== null && entry.value !== undefined && entry.value !== ''
  );

  if (visible.length === 0) {
    return null;
  }

  return (
    <Box>
      <Button
        size='small'
        onClick={() => setOpen(current => !current)}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
      >
        {open ? 'Technische Details ausblenden' : label}
      </Button>
      <Collapse in={open}>
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'background.default',
          }}
        >
          {visible.map(entry => (
            <Box
              key={entry.label}
              sx={{
                display: 'flex',
                gap: 2,
                alignItems: 'flex-start',
                py: 0.25,
              }}
            >
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ minWidth: 160 }}
              >
                {entry.label}
              </Typography>
              <Typography
                variant='caption'
                sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}
              >
                {entry.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};
